module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "room-detail"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-3": "",
      "align-items-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md8": ""
    }
  }, [_c('media', {
    attrs: {
      "item": _vm.mediaItem
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-items-center": ""
    }
  }, [_c('div', {
    staticClass: "pr-2"
  }, [_c('room-status', {
    staticClass: "mb-0",
    attrs: {
      "clean-state": _vm.room.clean_state,
      "number": _vm.room.number,
      "code": _vm.room.code,
      "status-icon": _vm.room.icon,
      "room": _vm.room,
      "size": 'medium',
      "extra-state": _vm.room.extra_state,
      "name": _vm.room.name
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "time-container body-border-left"
  }, [_c('clock', {
    attrs: {
      "minute": _vm.room.time_minute,
      "second": _vm.room.time_second
    },
    on: {
      "increase-time": _vm.increaseTime
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('list-detail-description', {
    staticClass: "px-2 mb-3",
    attrs: {
      "details": _vm.mediaItem.details
    }
  })], 1), _vm._v(" "), _c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "selectable": false,
      "include-delete": false,
      "include-export-to-excel": true,
      "include-options": true,
      "include-state": true,
      "include-images": true
    },
    on: {
      "on-search-event": _vm.onSearchData,
      "go-to-photos-page": _vm.openRoomPhotos,
      "on-sortable-event": _vm.columnSortableEvent
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.name) + " " + _vm._s(props.row.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.clean_type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.time_standard))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.time_done))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.supervisor))])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69f9fb9b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/housekeeping/rooms/RoomDetail.vue
// module id = 1661
// module chunks = 38